// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from 'D:/demo/work/yunDong/stateless-portal/node_modules/.pnpm/@umijs+runtime@3.5.43_react@16.14.0/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/Loading';

export function getRoutes() {
  const routes = [
  {
    "title": "foo",
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__foo' */'@/pages/foo'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "title": "postdoctor",
    "path": "/postdoctor",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__postdoctor' */'@/pages/postdoctor'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "title": "tutorDetail",
    "path": "/tutorDetail",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__postdoctor__tutorDetail' */'@/pages/postdoctor/tutorDetail'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "title": "furtherStudy",
    "path": "/furtherStudy",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__furtherStudy' */'@/pages/furtherStudy'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
